import { render, staticRenderFns } from "./quotes.vue?vue&type=template&id=443e71aa&"
import script from "./quotes.vue?vue&type=script&lang=js&"
export * from "./quotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("c:\\xampp\\htdocs\\app.poojalab.com\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('443e71aa')) {
      api.createRecord('443e71aa', component.options)
    } else {
      api.reload('443e71aa', component.options)
    }
    module.hot.accept("./quotes.vue?vue&type=template&id=443e71aa&", function () {
      api.rerender('443e71aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/install/quotes.vue"
export default component.exports